import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { InlineWidget } from 'react-calendly'
import { useTheme } from '@material-ui/core'
import { useCalendly } from '../../utils/useCalendly'
import { getTranslations } from '../../i18n'
import { setFullLocale } from '../../utils/utils'
import SharedHead from '../../components/Global/SharedHead'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useLastOrder } from '../../utils/useLastOrder'
import { createClient, getSingleDocument } from '../../prismicio'

type Tprops = {
  parameters?: any
  stores?: any
  main?: any
  user?: any
}

const mapStateToProps = (state) => ({
  parameters: state.parameters,
  stores: state.stores,
  user: state.user,
})

const InStorePickupPage = ({ parameters, stores, main, user }: Tprops) => {
  const themes = useTheme()
  const calendly = useCalendly(
    stores?.selectedStore,
    parameters?.items?.in_store
  )
  const lastOrder = useLastOrder()
  const { trackPageView } = useMatomo()

  useEffect(() => {
    trackPageView({ documentTitle: 'In Store Pickup appointment page' })
  }, [])

  return (
    calendly.ready &&
    calendly.returnUrl &&
    calendly.pickupUrl && (
      <div>
        <SharedHead datas={main} />
        <InlineWidget
          url={calendly.pickupUrl}
          styles={{
            height: '1000px',
          }}
          pageSettings={{
            hideEventTypeDetails: false,
            hideLandingPageDetails: true,
            hideGdprBanner: true,
            primaryColor: themes.palette.primary.main.replace('#', ''),
            textColor: themes.palette.common.black.replace('#', ''),
          }}
          prefill={{
            email: user?.user?.email,
            firstName: user?.user?.firstName,
            lastName: user?.user?.lastName,
            customAnswers: {
              a1: lastOrder?.items?.length > 0 ? lastOrder?.number : '',
              a2: user?.user?.phoneNumber ? user?.user?.phoneNumber : '',
            },
          }}
        />
      </div>
    )
  )
}

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const general = await getSingleDocument(client, lang, 'general')

  return {
    props: {
      main: general,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}

export default connect(mapStateToProps)(InStorePickupPage)
